<template>
  <div class="browseNew">
    <div class="section" v-if="browseAccountValue==1">
      <div class="search">
        <div class="searchLeft">
        </div>
        <div class="searchRight">
          <!-- 搜索 -->
          <div class="search-alert" v-if="showSearch">
            <!-- :placeholder="$t('recharge.pn')" -->
            <!-- v-model="inputText" -->
            <!-- @input实时查询 -->
            <!-- @keyup.enter.native -->
            <div class="searchDiv">
              <el-input class="searchAll" ref="iptFocus" v-model.trim="search.usr"
                @keyup.enter.native="getBrowseList(true)" :placeholder="this.$t('browse.pleaseUsr')" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <!-- 搜索 -->
              <span class="search-device" @click="getBrowseList(true)">{{ $t('recharge.Search') }}</span>
              <!-- 取消 -->
              <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span>
            </div>
          </div>
          <el-button class="button button-solid" @click.stop="showSearchBtn">
            <i class="el-icon-search"></i>
          </el-button>
          <!-- 添加子账户 -->
          <button type="button" class="button-upload" @click="addBrowse()">
            <span>{{ $t('browse.addBrowse') }}</span>
            <i class="iconfont icon-biaogegongneng_xinjian"></i>
          </button>
        </div>
      </div>
      <el-table class="tablemain tableloding" v-loading="isLoading" element-loading-spinner="el-icon-loading"
        height="100%" stripe border  :data="browseDataList"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" :empty-text="$t('account.nodata')">
        <el-table-column prop="usr" min-width="90px;" :show-overflow-tooltip="true"
        :label="$t('browse.usr')">
          <template  slot-scope="scope">
            <span class="redirect" @click="enterAccount(scope.row)">{{ scope.row.usr }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="email" min-width="90px;" :show-overflow-tooltip="true"
        :label="$t('browse.email')">
        </el-table-column>
        <el-table-column prop="mobile" min-width="90px;" :show-overflow-tooltip="true"
        :label="$t('browse.mobile')">
        </el-table-column>
        <el-table-column prop="gts" min-width="90px;" :show-overflow-tooltip="true"
        :label="$t('browse.gts')">
        </el-table-column>
        <el-table-column prop="desc" min-width="90px;" :show-overflow-tooltip="true"
        :label="$t('browse.desc')">
          <template slot-scope="scope">
            <span :title="scope.row.desc || '--'">{{ scope.row.desc || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="enable" width="140px;" :show-overflow-tooltip="true"
        :label="$t('browse.enableStatus')">
          <template slot-scope="scope">
            <span style="color: #30D096;" v-if="scope.row.enable==true">{{ $t('browse.Enable') }}</span>
            <span style="color: #ff7c79;" v-else>{{ $t('browse.Disable') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('firmware.Operation')" fixed="right" width="150px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button type="text" class="operation" :title="$t('datalogger.edit')"
              @click="editBrowse(scope.row)">
              <i class="iconfont icon-bianji"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('datalogger.delete')"
              @click="deleteBrowse(scope.row)">
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <!-- <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png"/>
                <div style="line-height: 32px">{{$t('account.nodata')}}</div></div> -->
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <span class="" style="margin-left:16px;"></span>
        <!-- v-show="paginationControl" -->
        <el-pagination class="pagination" background @size-change="getBrowseList(true)" @current-change="() => getBrowseList()"
          :current-page.sync="pagination.currentPage" :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize" layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total" popper-class="select-page">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <addBrowseAccount  @noticeBrowseAccountBox="showBrowseAccountListBox" v-if="browseAccountValue==2" ></addBrowseAccount>
    <editBrowseAccount  @noticeBrowseAccountBox="showBrowseAccountListBox"  :browseAccountListParam="browseAccountListParam" v-if="browseAccountValue==3" ></editBrowseAccount>
      <!-- 删除对话框 -->
      <!-- v-if="dialogVisible" -->
      <browse-dialog :title="$t('browse.deleteBrowse')" :visible.sync="deletedialog"
        :class="{ 'showDialog': deletedialog, 'hideDialog': !deletedialog }" width="30vw" noFooter>
        <div class="content_tishi" slot="content">
          <div class="tital">
            <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('browse.delete_browse') }}</span>
          </div>
          <div class="deletfotter" style="text-align:right;margin-top:28px;">
            <button type="button" class="btn btn-dark" @click="configdelete()" style="margin-right:10px;">{{
              $t('firmware.confirm') }}</button>
            <button type="button" class="btn btn-light" @click="deletedialog = false">{{ $t('firmware.cancel') }}</button>
          </div>
        </div>
      </browse-dialog>
  </div>
</template>
<script>
import browseDialog from "@/components/dialognew";
import textArea from "@/assets/EBUI/components/TextArea/index";
import addBrowseAccount from "./addBrowsenew";
import editBrowseAccount from "./editBrowsenew";
export default {
  components: {
    browseDialog,
    textArea,
    addBrowseAccount,
    editBrowseAccount
  },
  data () {
    return {
      browseAccountListParam:null,
      browseAccountValue:1,
      // 删除弹窗
      deletedialog:false,
      browseDataList:[],
      search:{
        usr:"",
      },
      pagination: {
        currentPage: 1,
        pagesize: 15,
        // 默认 0
        total: 0
      },
      isLoading:false,
      // 列表搜索开关
      showSearch:false,
      // 子账号id
      browseListId:"",
      browseListName:"",
    };
  },
  watch:{
  },
  created(){
    this.getBrowseList()
  },
  methods: {
     // 点击用户名打开该浏览者窗口
     enterAccount (info) {
      // }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              path: "/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
              }
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 删除子账号弹窗
    deleteBrowse(info){
      this.deletedialog=true
      this.browseListId=info.uid
    },
    // 删除子账号
    configdelete(){
      this.$request.get("delPlantBrowserEs",{uid:this.browseListId}).then(res=>{
        if (res.err==0) {
          this.$message.success(this.$t("browse.deleteSuccess"))
          this.getBrowseList()
        }else{
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        this.deletedialog=false
      })
    },
    // 关闭搜索框
    closeSearch () {
      this.showSearch = false;
      this.search.usr = '';
      this.getBrowseList();
    },
    showSearchBtn () {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      })
    },
    // 获取子账户列表信息
    getBrowseList(reset){
      if (reset) this.pagination.currentPage = 1;
      let params={
        usr:this.search.usr,
        page: this.pagination.currentPage-1,
        pagesize: this.pagination.pagesize
      }
      this.$request.get("queryPlantBrowsersEs",params).then(res=>{
        if (res.err==0) {
          this.browseDataList=res.dat.plantBrowser
          this.pagination.total=res.dat.total
        }else{
          this.browseDataList=[]
          this.pagination.total=0
        }
      })
    },
    showBrowseAccountListBox (val) {
      this.browseAccountValue =val
      this.closeSearch()
    },
    // 添加子账户
    addBrowse(){
      this.browseAccountValue = 2;
      // this.$router.push({
      //   path: "addBrowse",
      // });
    },
    // 编辑子账户
    editBrowse(info){
      this.browseAccountValue = 3;
      this.browseAccountListParam =info
      // this.$router.push({
      //   path: "editBrowse",
      //   query: {
      //     email:info.email,
      //     enable:info.enable,
      //     gts:info.gts,
      //     mobile:info.mobile,
      //     uid:info.uid,
      //     usr:info.usr,
      //     desc:info.desc,
      //     plant:info.plant,
      //   }
      // });
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");
  .browseNew{
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: auto;
    margin: 20px;
    // 可点击跳转的标题
    .redirect {
      color: @primaryTextColor;
    }
    .btn {
      height: 32px;
      padding: 6px 12px;
      border-radius: 6px;
      font-size: 14px;
      cursor: pointer;
    }

    .btn-dark {
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      border: none;
    }

    .btn-light {
      background: transparent;
      color: @primaryTextColor;
      border: 1px solid @primaryTextColor;
    }
    .search {
      margin: 0;
      // align-self: flex-end;
      align-items: center;
      display: flex;
      justify-content: space-between;
      position: relative;
      /deep/.el-range-editor .el-range-input{
        background-color: #222d35;
        color: #fff;
      }
      /deep/.el-range-separator{
        color: #fff !important;
        line-height: 48px !important;
      }
      /deep/.el-icon-date:before {
        content: "";
        display: inline-block;
        position: absolute;
        top: 12px;
        left: 0px;
        height: 24px;
        width: 24px;
        background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
        background-size: 100%;
        background-position: center;
      }
      .searchRight{
        display: flex;
        justify-content: flex-end;
        .buttonDeviceJurisdiction {
          padding: 0 17px 0 12px;
          background-color: @primaryTextColor;
          color: #222D35;
          border-radius: 0;
          span {
            padding-left: 5px;
          }
        }
      }
      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }
      /deep/.el-select {
          width: 120px;
          border-right: 1px solid #738089;
        }

        /deep/.el-select:hover {
          background: @primaryColorTransparency30;
        }

        /deep/.el-input {
          width: 100%;
          text-align: center;
        }

        /deep/.el-input__inner {
          background: transparent;
          border: none;
          height: 48px;
          line-height: 48px;
          color: #ffffff;
          padding: 0 16px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        .button {
          height: 48px;
          line-height: 48px;
          padding: 0 25px;
          margin-top: 0px;
          color: @primaryTextColor;
          background: transparent;
          border: none;
        }
        .search-alert {
          position: absolute;
          top: 0;
          left: 0;
          // right: 125px;
          width: 100%;
          height: 48px;
          z-index: 0;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;

          .searchDiv {
            position: absolute;
            top: 0;
            // left: 0;
            right: 0;
            width: 400px;
            height: 48px;
            z-index: 2;
            background: rgb(34, 45, 53);
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .searchAll {

            // display: flex;
            // align-items: center;
            // justify-content: flex-end;
            /deep/.el-input__inner {
              width: 220px;
              padding-left: 10px !important;
            }
          }

          .search-device {
            display: inline-block;
            line-height: 48px;
            padding: 0 15px;
            font-size: 14px;
            background: #202D35;
            color: #33FFB6;
            cursor: pointer;

            &:hover {
              background: @primaryColorTransparency30;
              color: rgb(255, 255, 255, 1);
            }
          }

          .search-hide {
            display: inline-block;
            // position: absolute;
            // right: -58px;
            line-height: 48px;
            padding: 0 15px;
            font-size: 14px;
            background: #202D35;
            color: #7B8395;
            border-left: 1px solid #7B8395;
            cursor: pointer;

            &:hover {
              background: @primaryColorTransparency30;
              color: rgb(255, 255, 255, 1);
            }
          }

          /deep/.el-input {
            flex: 1;
          }

          /deep/.el-input .el-input__clear {
            width: 48px;
            color: #7B8395;
          }

          /deep/.el-input .el-input__clear:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }

          /deep/.el-input .el-input__inner,
          /deep/.el-input .el-input__inner:hover {
            height: 48px;
            border-radius: 0px;
            border: none;
            background: #202D35;
            color: #ffffff;
            padding-left: 40px;
          }

          /deep/.el-input__prefix {
            left: -20px;
          }

          /deep/.el-input__icon {
            width: 40px;
          }

          /deep/.el-input__suffix {
            right: 0px;
          }

          /deep/.el-input__suffix:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }

          /deep/.el-icon-circle-close:before {
            content: 'X'
          }

          /deep/.el-input:not(:last-child) {
            margin-right: 0px;
          }
        }
      .button-upload {
        display: flex;
        //多语言状态下文字间隔优化
        line-height: 16px;
        justify-content: space-between;
        align-items: center;
        width: 120px;
        height: 48px;
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        border-radius: 0px;
        border: none;
        cursor: pointer;
        .ico-download {
          width: 16px;
          height: 16px;
          background: url(../../assets/img/general/Icon_Download.png) no-repeat;
          background-size: 100%;
          background-position: center;
          margin-left: 10px;
        }
      }
    }
    .section{
      flex: 1;
      display: flex;
      border-radius: 0px;
      border: none;
      flex-direction: column;
      background: rgb(34, 45, 53);
      padding: 0px;
      overflow: auto;
      /deep/.el-icon-loading {
        font-size: 28px;
      }
      .tableloding {

        // 加载数据时遮罩
        /deep/.el-loading-mask {
          background-color: rgb(34, 45, 53, .5);
        }

        /deep/.el-loading-spinner i {
          color: @primaryTextColor;
        }
      }
      .tablemain{
        border: none;
        background-color: rgb(34, 45, 53);
        .operation i {
          color: @primaryTextColor;
        }
        .operation1 i {
          color: @primaryColorTransparency30;
        }

        /deep/.el-table--border::after,
        /deep/.el-table--group::after {
          width: 0px;
        }

        /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
          width: 16px;
          height: 16px;
          background: transparent;
          border: 1px solid rgb(180, 184, 193);
          border-radius: 0px;
        }

        /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
          top: 2px;
          left: 5px;
        }

        /deep/.el-table__header th {
          height: 48px;
        }

        /deep/.el-table__header th.is-leaf {
          border-color: rgba(198, 209, 221, 0.5);
          border-bottom: none;
        }

        /deep/.el-table__header th>.cell {
          font-weight: normal;
          font-size: 12px;
        }

        /deep/.el-table__body tr,
        /deep/.el-table__body td {
          background-color: rgb(34, 45, 53);
          color: #ffffff;
          border-color: rgba(198, 209, 221, 0.5);
        }

        /deep/.el-table__body td.el-table-column--selection {
          background-color: rgb(65, 80, 90);
          color: #ffffff;
        }

        /deep/.el-table__body .cell.el-tooltip {
          font-size: 14px;
        }

        /deep/.el-table__fixed-right::before,
        /deep/.el-table__fixed::before {
          display: none;
        }

        ::-webkit-scrollbar {
          width: 6px;
          height: 6px;
          background-color: #222d35;
        }

        // 关于头部右侧空白
        /deep/.el-table__fixed-right-patch {
          background-color: rgb(65, 80, 90);
          border-bottom: none;
        }

        /deep/th.gutter {
          background-color: rgb(65, 80, 90);
        }
      }
      .tablebottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid rgba(198, 209, 221, 0.5);

        // 分页
        .pagination {
          line-height: 48px;
          height: 48px;
          padding: 0;
          margin: 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-right: 16px;

          /deep/.el-pager li {
            vertical-align: middle;
          }

          /deep/.el-select .el-input {
            width: 90px;
            margin: 0px;
          }

          /deep/.el-input .el-input__inner {
            background-color: #202D35;
            color: #ffffff;
          }

          /deep/.el-input__suffix {
            right: 10px;
          }

          /deep/.el-pagination__sizes {
            margin: 0px;
            height: 48px;
            line-height: 48px;
          }

          /deep/.el-pagination__total {
            color: #fff;
            padding-left: 15px;
            border-left: 1px solid #7B8395;
            height: 48px;
            line-height: 48px;
          }

          /deep/.el-pager li:not(.disabled).active {
            // background: #15C491;
            // color: #ffffff;
            background-color: #2B3842;
            color: #15C491;
          }

          // li:not(.disabled):not(.active):hover
          /deep/.el-pager li:not(.disabled):hover {
            background-color: @primaryColorTransparency30;
            color: rgba(255, 255, 255, 1);
          }

          /deep/.el-pager li {
            background-color: #2B3842;
            color: #7B8395;
          }

          // 页条数下拉
          /deep/.el-select .el-input .el-input__inner {
            border: none;
            height: 48px;
            line-height: 48px;
            border-radius: 0px;
          }

          /deep/.el-select .el-input .el-input__inner:hover {
            background: @primaryColorTransparency30;
          }

          // 跳页
          /deep/.el-pagination__jump {
            color: #ffffff;
          }

          /deep/.el-pagination__editor {
            padding: 0px 6px;
          }

          /deep/.el-pagination__editor.el-input .el-input__inner {
            border: 1px solid #7B8395;
          }
        }

        // 分页前后按钮
        /deep/.el-pagination.is-background .btn-next,
        /deep/.el-pagination.is-background .btn-prev {
          background-color: #2B3842;
          color: #7B8395;
        }

        /deep/.el-pagination.is-background .btn-next:hover,
        /deep/.el-pagination.is-background .btn-prev:hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pagination.is-background button[disabled],
        /deep/.el-pagination.is-background button[disabled]:hover {
          background-color: #2B3842;
          color: #7B8395;
        }
      }
    }
  }

</style>
<style>
  
</style>